export default "__VITE_ASSET__BqP7y2rp__"